'use client';

import {
  analyticSolutionsIcon,
  ecommerceIcon,
  mobileAppDevelopmentIcon,
  productDesignIcon,
  seoIcon,
  serverHostingIcon,
  webDevelopmentIcon,
} from '@/assets/icons'
import { useLocale, useTranslations } from 'next-intl'
import { StaticImageData } from 'next/image'

export const useServicesLinks = () => {
  const t = useTranslations();
  return [
    {
      title: t('links.mobileAppDevelopment'),
      url: '/services/mobile-app-development',
      img: mobileAppDevelopmentIcon,
      description: t('mobileAppDevelopment.whatWeOfferCardDescription'),
    },
    {
      title: t('links.webDevelopment'),
      url: '/services/web-development',
      img: webDevelopmentIcon,
      description: t('webDevelopment.whatWeOfferCardDescription'),
    },
    {
      title: t('links.analyticSolutions'),
      url: '/services/analytic-solutions',
      img: analyticSolutionsIcon,
      description: t('analyticSolutions.whatWeOfferCardDescription'),
    },
    {
      title: t('links.projectDesign'),
      url: '/services/project-design',
      img: productDesignIcon,
      description: t('projectDesign.whatWeOfferCardDescription'),
    },
    {
      title: t('links.serverHosting'),
      url: '/services/server-hosting',
      img: serverHostingIcon,
      description: t('serverHosting.whatWeOfferCardDescription'),
    },
    {
      title: t('links.seo'),
      url: '/services/seo',
      img: seoIcon,
      description: t('seo.whatWeOfferCardDescription'),
    },
    {
      title: t('links.e_commerce'),
      url: '/services/e-commerce',
      img: ecommerceIcon,
      description: t('e_commerce.whatWeOfferCardDescription'),
    },
  ];
};

export type Link = {
  title: string;
  url: string;
  children?: LinkChildren[] | undefined;
};

export type LinkChildren = {
  title: string
  url: string
  img: string | StaticImageData
  description: string
}


export const useLinks = (): Link[] => {
const locale = useLocale()

  const t = useTranslations()
  const servicesLinks = useServicesLinks()
  return [
    {
      title: t('links.home'),
      url: `/${locale}/`,
    },
    {
      title: t('links.aboutUs'),
      url: `/${locale}/about`,
    },
    {
      title: t('links.services'),
      url: `/${locale}/services`,
      children: servicesLinks.map(link => ({
        ...link,
        url: `/${locale}${link.url}`,
      })),
    },
    {
      title: t('links.contactUs'),
      url: `/${locale}/contact-us`,
    },
  ]
}
